// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6961cfe6","239":"aca3b4d3","453":"27151888","732":"e02830fd"}[chunkId] + ".chunk.js";
};